import * as ENDPOINTS from "routes/ApiEndpoints";
import { AJ_WEB_CONNECTOR } from "Constants";
import AccessControl from "components/common/services/RolesAndPermissions/AccessControl";
import { t, translate } from "components/CentralDataMangement/translation/Translation";
import { Link, useNavigate } from "react-router-dom";
import { validateForm, validateSelectField } from "components/common/services/ValidationService";
import Title from "components/common/atoms/Title";
import SelectWithSearch from "components/common/atoms/SelectWithSearch";
import { OptionProps, ValidationRules } from "components/common/utlis/TypeAnnotations";
import { useEffect, useState } from "react";
import { ApiCall } from "components/common/services/ApiServices";
import CustomNotify from "components/common/atoms/CustomNotify";
import Button from "components/common/atoms/Button";
import LoadingIcon from "components/common/utlis/LoadingIcon";

const LlmProvider: React.FC = () => {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [formData, setFormData] = useState({
		llmProvider: "",
		llmModel: "",
	});

	const [dropDown, setDropDown] = useState({
		llmProviders: [] as OptionProps[],
		llmModels: [] as OptionProps[],
		actualLlmModels: [] as OptionProps[]
	});

	const [errors, setErrors] = useState({
		llmProvider: "",
		llmModel: "",
	});

	const permissionType = "create";
	const permissionObject: any = {
		permission: "Content creation",
	};
	permissionObject[permissionType] = true;


	const validation = (
		name: string,
		value: string | boolean,
		isSingleFieldValidation: boolean = false
	) => {

		const validationRules: ValidationRules = {
			llmProvider: [validateSelectField],
			llmModel: [validateSelectField]
		};

		const validationErrors = validateForm(
			{ ...formData, [name]: value },
			validationRules,
			isSingleFieldValidation ? name : undefined
		);

		if (isSingleFieldValidation && Object.keys(errors).length > 0) {
			setErrors((prevErrors) => ({
				...prevErrors,
				[name]: validationErrors[name],
			}));
		} else {
			setErrors(validationErrors as any);
		}

		if (Object.keys(validationErrors).length > 0) {
			return false;
		}

		return true;
	};
	useEffect(() => {
		const data = { type: 'llmLatestSlugs' };
		const fetchDataForEditing = async (data: any) => {
			try {
				const response = await ApiCall.service(
					ENDPOINTS.GET_LLM_DETAILS,
					"POST",
					data,
					true,
					AJ_WEB_CONNECTOR
				);
				if (response?.status === 200) {
					const data = response?.data;
					if (data.llmData && Object.keys(data.llmData).length > 0) {
						setFormData(data.llmData);
						setDropDown((prev) => ({
							...prev,
							llmProviders: data.dropDowns?.llmProviders || [],
							actualLlmModels: data.dropDowns?.llmModels || [],
						}));
						if (data.llmData.llmProvider.value) {
							getLlmModelOptions(data.llmData.llmProvider.value, data.dropDowns?.llmModels);
						}
					} else {
						setDropDown((prev) => ({
							...prev,
							llmModels: data.dropDowns?.llmModels || [],
							llmProviders: data.dropDowns?.llmProviders || [],
							actualLlmModels: data.dropDowns?.llmModels || [],
						}))
					}

				} else {
					CustomNotify({
						type: "error",
						message: t("Some error occured"),
					});
				}
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		};

		fetchDataForEditing(data);

	}, []);

	const handleSelectChange = (selectedOption: any, name: string) => {
		setFormData((prevFormData: any) => ({
			...prevFormData,
			[name]: selectedOption,
		}));

		if (selectedOption?.value && name == 'llmProvider') {
			getLlmModelOptions(selectedOption?.value, dropDown.actualLlmModels);
			setFormData((prevFormData: any) => ({
				...prevFormData,
				llmModel: null,
			}));
		}
		validation(name, selectedOption, true);
	};

	const getLlmModelOptions = (llmProviderId: number | string, object: OptionProps[]) => {
		const modelOptions = object.filter(model => model?.providerId == llmProviderId);
		setDropDown((prev) => ({
			...prev,
			llmModels: modelOptions || []
		}));
	}

	const handleSubmit = async (e: React.FormEvent) => {
		setLoading(true);
		e.preventDefault();
		const { name, value } = e.target as HTMLInputElement;
		const data = { type: 'llmLatestSlugs', ...formData };
		if (validation(name, value)) {
			let response = await ApiCall.service(
				ENDPOINTS.CREATE_OR_UPDATE_LLM_DETAILS,
				"POST",
				data,
				false,
				AJ_WEB_CONNECTOR
			);
			if (response?.status === 200) {
				navigate(-1);
				CustomNotify({ type: "success", message: response?.msg });
			} else {
				CustomNotify({
					type: "error",
					message: t("Some error occured"),
				});
			}
		}
		setLoading(false);
	};

	return (
		<AccessControl
			requiredPermissions={[permissionObject]}
			renderNoAccess={true}
		>
			<>
				<Title title={t("LLM latest slugs")} />
				<form onSubmit={handleSubmit}>
					<div className="form-border">
						<div className="row">
							<div className="col-sm-12 col-md-6 col-lg-4">
								<SelectWithSearch
									name="llmProvider"
									title={t("Provider")}
									isMandatory={true}
									search={true}
									options={dropDown.llmProviders}
									value={formData.llmProvider}
									onChange={(e) => handleSelectChange(e, "llmProvider")}
									isMulti={false}
									isTranslate={true}
									error={errors.llmProvider}
								/>
							</div>
							<div className="col-sm-12 col-md-6 col-lg-4">
								<SelectWithSearch
									name="llmModel"
									title={t("Model")}
									isMandatory={true}
									search={true}
									options={dropDown.llmModels}
									value={formData.llmModel}
									onChange={(e) => handleSelectChange(e, "llmModel")}
									isMulti={false}
									isTranslate={true}
									error={errors.llmModel}
								/>
							</div>
						</div>
					</div>

					<div className="row backPadding">
						<div className="col-md-4 align-self-center">
							<Link
								to=""
								onClick={() => navigate(-1)}
								className=" back-btn text-decoration-underline"
							>
								{t("Back")}
							</Link>
						</div>
						<div className="col-md-8 text-end">
							{!loading ? (
								<Button
									title={t("Save")}
									type="submit"
									className="float-end form-button shadow-none"
									handleClick={handleSubmit}
								/>
							) : (
								<LoadingIcon
									iconType="bars"
									color="#e55496"
									height={"3vw"}
									width={"3vw"}
									className="ms-auto"
								/>
							)}
						</div>
					</div>
				</form>
			</>
		</AccessControl>
	);
};

export default translate(LlmProvider);
